import { render, staticRenderFns } from "./BaseFormErrors.vue?vue&type=template&id=7af4e2aa&"
import script from "./BaseFormErrors.vue?vue&type=script&lang=js&"
export * from "./BaseFormErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports